import { organization } from '../data/siteData';
import { assetPath } from '../utils/assetPath';

export default function WhatsAppButton() {
  const message = encodeURIComponent('Hola, quiero recibir información sobre los programas de Fundación Tony.');
  const track = (network) => {
    if (window.gtag) window.gtag('event', 'social_click', { network, location: 'floating_buttons' });
  };

  return (
    <div className="social-float" aria-label="Redes sociales y contacto">
      <a
        className="social-float__button social-float__button--facebook"
        href={organization.facebook}
        target="_blank"
        rel="noreferrer"
        aria-label="Visitar Facebook de Fundación Tony"
        onClick={() => track('facebook')}
      >
        <span>Facebook</span>
        <img src={assetPath('/assets/icons/facebook.svg')} alt="" />
      </a>
      <a
        className="social-float__button social-float__button--instagram"
        href={organization.instagram}
        target="_blank"
        rel="noreferrer"
        aria-label="Visitar Instagram de Fundación Tony"
        onClick={() => track('instagram')}
      >
        <span>Instagram</span>
        <img src={assetPath('/assets/icons/instagram.svg')} alt="" />
      </a>
      <a
        className="social-float__button social-float__button--whatsapp"
        href={`https://wa.me/${organization.whatsapp}?text=${message}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Solicitar información por WhatsApp"
        onClick={() => track('whatsapp')}
      >
        <span>Requiero información</span>
        <img src={assetPath('/assets/icons/whatsapp.svg')} alt="" />
      </a>
    </div>
  );
}
